import { md5 } from '@nu-art/ts-common';
/**
 * Quick resolver to get the ICD item name.
 * @param item The currently parsed ICD item
 */
export const ResolveICDName = (item) => {
    return item.title['@value'];
};
/**
 * Normalize variable name, in order to get the most accurate results
 * @param varName The variable name to normalize
 */
export const normalizeString = (varName) => {
    return varName.toLowerCase().replace(/[-().[\],:\s]/g, '');
};
/**
 * Get a template of a new icd reference to upsert to the db
 * @param icdCode The icd code to build a ref for
 */
export const DBRefTemplate = (icdCode) => {
    const refUID = md5(`icdRef/${icdCode}`); // in order to make sure this is consistent
    return { _id: refUID, uid: refUID, type: 'icdCode', data: { id: icdCode } };
};
//# sourceMappingURL=utils.js.map